import type { MechKey } from './keys';

export const fr: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mécanique · 2D',
  'panel.scene': 'Scène',
  'panel.dims': 'Paramètres',
  'panel.style': 'Apparence',
  'panel.action': 'Contrôles',
  'style.body': 'Corps',
  'style.vector': 'Vecteurs',
  'style.ground': 'Sol',
  'style.forces': 'Afficher les forces',
  'style.trace': 'Afficher la trace',
  'style.labels': 'Étiquettes vectorielles',
  'hint.line1': 'Cliquez sur lecture pour démarrer · faites glisser les corps pour les déplacer',
  'hint.line2': 'Sandbox : choisissez une forme, puis cliquez pour la placer',
  'scene.incline': 'Plan incliné',
  'scene.projectile': 'Mouvement de projectile',
  'scene.pendulum': 'Pendule',
  'scene.springMass': 'Système masse-ressort',
  'scene.collisions': 'Collisions',
  'scene.atwood': "Machine d'Atwood",
  'scene.circular': 'Mouvement circulaire',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'angle (°)',
  'dim.friction': 'frottement',
  'dim.mass': 'masse',
  'dim.massA': 'masse A',
  'dim.massB': 'masse B',
  'dim.velocity': 'vitesse',
  'dim.angleLaunch': 'angle de lancement (°)',
  'dim.gravity': 'gravité',
  'dim.gravityX': 'gravité x',
  'dim.gravityY': 'gravité y',
  'dim.length': 'longueur',
  'dim.damping': 'amortissement',
  'dim.spring': 'rigidité',
  'dim.restitution': 'restitution',
  'dim.radius': 'rayon',
  'dim.speed': 'rapidité',
  'action.play': 'Lecture',
  'action.pause': 'Pause',
  'action.step': 'Pas',
  'action.reset': 'Réinitialiser',
  'action.speed': 'Vitesse',
  'action.clear': 'Effacer',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravité',
  'forceName.normal': 'Normale',
  'forceName.friction': 'Frottement',
  'forceName.tension': 'Tension',
  'forceName.spring': 'Ressort',
  'forceName.applied': 'Appliquée',
  'forceName.air': "Résistance de l'air",
  'palette.box': 'Boîte',
  'palette.circle': 'Balle',
  'palette.ramp': 'Rampe',
  'palette.ground': 'Sol',
  'palette.hint': 'Choisissez une forme, puis cliquez sur le canvas pour la placer.',
  'panel.forces': 'Forces observées',
  'forces.empty': "Aucune pour l'instant — lancez la scène",
};
